import { CertificateLayout } from './CertificateLayout';

const LOGO_SRC = '/pozytronLogo.svg';

/** A4 paper geometry (portrait). Width matches the Figma certificate; height
 *  follows the ISO 216 ratio (210 × 297 mm → ×√2). */
export const PAGE_WIDTH = 892;
export const PAGE_HEIGHT = Math.round((PAGE_WIDTH * 297) / 210); // 1262

/** Paper padding (`p-8`) on every side of the sheet. */
export const PAPER_PADDING = 32;
/** Bordered frame vertical padding (`py-6`) inside the paper. */
export const FRAME_PADDING_Y = 24;
/** Gap between the repeated logo header and the page content (`mb-8`). */
export const LOGO_GAP = 32;
/** Gap between stacked content blocks on a page (`gap-10`). */
export const BLOCK_GAP = 40;
/** Inner width available to content: paper width minus paper + frame x-padding. */
export const CONTENT_WIDTH = PAGE_WIDTH - 2 * PAPER_PADDING - 2 * PAPER_PADDING;

/** Subfields shown per equipment / form-fields card. */
export const FIELDS_PER_CARD = 6;
/** Fixed height (px) of a 6-subfield detail card (chrome + 3 rows + 2 gaps). */
export const FIELD_CARD_HEIGHT = 200;

interface CertificatePageProps {
  includeTechnicianDetail: boolean;
  footerText: string;
  /** Render the signature/footer block (only the last page in a set). */
  showSignatures: boolean;
  children: React.ReactNode;
}

/**
 * A single fixed-height A4 certificate sheet: white paper with the rotated
 * watermark, the bordered frame (repeated logo header), the supplied page
 * content, and — when `showSignatures` is set — the signature/footer block.
 */
export const CertificatePage = ({
  includeTechnicianDetail,
  footerText,
  showSignatures,
  children,
}: CertificatePageProps) => (
  <div
    className="relative bg-white rounded-[10px] shadow-[0px_25px_50px_-12px_rgba(0,0,0,0.25)] shrink-0"
    style={{ width: PAGE_WIDTH, height: PAGE_HEIGHT }}
  >
    {/* Watermark — clipped to paper shape */}
    <div
      className="absolute inset-0 rounded-[10px] overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      <div
        className="absolute top-8 left-0 flex items-center justify-center"
        style={{ width: 831, height: 831 }}
      >
        <img
          src={LOGO_SRC}
          alt=""
          className="opacity-[0.05] select-none"
          style={{ transform: 'rotate(-45deg)', width: 952, maxWidth: 'none' }}
        />
      </div>
    </div>

    <div className="relative p-8 h-full">
      <CertificateLayout
        includeTechnicianDetail={includeTechnicianDetail}
        footerText={footerText}
        showSignatures={showSignatures}
      >
        {children}
      </CertificateLayout>
    </div>
  </div>
);
